import React, { useContext } from 'react';
import { Typography, Stack, Grid, Chip } from '@mui/material';
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";

export const TAG_QUERY_PARAM = 'tagged'

function removeTag(tagToRemove, searchParams) {
  const updatedParams = new URLSearchParams(searchParams.toString());
  const tagged = updatedParams.get(TAG_QUERY_PARAM);
  if (!tagged) return updatedParams;

  const tags = tagged.split(',').filter(tag => tag !== tagToRemove);
  if (tags.length > 0) {
    updatedParams.set(TAG_QUERY_PARAM, tags.join(','));
  } else {
    updatedParams.delete(TAG_QUERY_PARAM);
  }

  return updatedParams;
}

function addTag(tagToAdd, searchParams) {
  const updatedParams = new URLSearchParams(searchParams.toString());

  const tagged = updatedParams.get(TAG_QUERY_PARAM);

  const tags = tagged?.split(',') || []
  if(tags.indexOf(tagToAdd) === -1) {
    updatedParams.set(TAG_QUERY_PARAM, [...tags, tagToAdd].join(','));
  }

  return updatedParams
}

export function Tag(props = {tag: '', onClick: undefined, onMouseDown: undefined, clickable: false, onDelete: undefined, sx: undefined}) {
  const {
    tag,
    onClick,
    onMouseDown,
    clickable,
    onDelete,
    sx,
  } = props
  return <Chip
    className='tag'
    key={tag}
    size='small'
    onMouseDown={onMouseDown}
    onClick={onClick}
    label={tag}
    clickable={clickable}
    onDelete={onDelete}
    sx={sx}
  />
}

export function AppliedFilters(props = {}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = (searchParams.get(TAG_QUERY_PARAM))?.split(',') || []
  const {
    sx
  } = props
  return (
    <Stack sx={sx} direction="row" gap={1} alignItems='center'>
      <Typography variant='subtitle1' fontWeight='bold'>Tagged:</Typography>
      {filters.map((f, i) => {
        const tag = f.replace(/tag:/, '')
        return <Tag
          key={'tag-' + i}
          clickable
          size='small'
          tag={tag}
          onDelete={() => {
            setSearchParams(removeTag(tag, searchParams))
          }}
        />
      })
      }
    </Stack>
  )
}

export default function Tags(props = {tags: undefined, onSelectTag: undefined, clickable: false, sx: undefined}) {

  const navigate = useNavigate()
  const {
    tags,
    onSelectTag = () => { },
    clickable,
    sx,
    className,
    sitePath
  } = props

  const [searchParams, setSearchParams] = useSearchParams();

  const tagsArray = tags
    .split(',')
    .reduce((s, tag) => {
      if (tag.indexOf('tag:') > -1) s.push(tag.split('tag:')[1])
      return s
    }, [])

  return (
    <Stack sx={sx} className={`tags-container${className ? ' ' + className : ''}`} gap={0.5} direction='row' justifyItems='flex-start' flexWrap='wrap'>
      {tagsArray.map((tag, i) => {
        return <Tag
          key={tag}
          clickable
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            if (onSelectTag) onSelectTag()
            if (!clickable) return;

            const nextParams = addTag(tag, searchParams);
            const search = createSearchParams(nextParams).toString();


            if(sitePath) {
              const path = `/${sitePath}?${search}`
              navigate(path)
            } else {
              setSearchParams(addTag(tag, searchParams))
            }

          }}
          onMouseDown={event => event.stopPropagation()}
          tag={tag}
        />
      })}
    </Stack>
  )
}